"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDatasheet = void 0;
const core_1 = require("@apitable/core");
function loadDatasheet(database, datasheetId, successCb, overWrite = false, extra, failCb) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const state = getState();
        const datasheetState = core_1.Selectors.getDatasheet(state, datasheetId);
        const { shareId, templateId, embedId } = state.pageParams;
        const { recordIds } = extra || {};
        const datasheetLoading = core_1.Selectors.getDatasheetLoading(state, datasheetId);
        if (datasheetLoading) {
            return;
        }
        const needLoad = !datasheetState || datasheetState.isPartOfData || overWrite;
        const datasheet = yield database.getDatasheet(datasheetId, {
            loadOptions: {
                shareId,
                templateId,
                embedId,
                recordIds,
                dispatch,
                getState,
                needLoad,
            },
            storeOptions: {
                // recordIds exsits means that only part of recordsIds data is needed @boris
                isPartOfData: Boolean(recordIds),
                needLoad,
            },
        });
        if (datasheet) {
            successCb === null || successCb === void 0 ? void 0 : successCb(datasheet);
        }
        else {
            failCb === null || failCb === void 0 ? void 0 : failCb();
        }
    });
}
exports.loadDatasheet = loadDatasheet;
